<template>
  <v-container>
    <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
      <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span
          class="black--text subtitle-1">Speichern</span></v-btn>
    </div>
    <div class="my-3">
      <h1 class="uiTitle header">
        Begründete Abweichungen
      </h1>
      <p class="subTitle">
        {{ $t('abweichungen.text') }}
      </p>
    </div>
    <p class="validationError" role="alert" v-if="errorText">
      <v-icon style="color:#c50517">mdi-alert</v-icon>
      <strong>{{ $t('abweichungen.generalError') }}</strong>
    </p>

    <p class="merkmalTitle" v-html="$t('abweichungen.wasser')"></p>
    <p v-html="$t('abweichungen.wasserAText')">
    </p>
    <p v-html="$t('abweichungen.wasserBText')">
    </p>
    <div class="d-flex justify-center">
      <v-text-field v-model="abweichungen.wasser" reverse label="(-0,70 Euro bis 0,00 Euro)"></v-text-field>
    </div>
    <p class="validationError" role="alert" v-if="validationError.wasserError">
      <v-icon style="color:#c50517">mdi-alert</v-icon>
      <strong>{{ $t('abweichungen.wasserValidation') }}</strong>
    </p>

    <p v-html="$t('abweichungen.rueckgebaeude')"></p>
    <p v-html="$t('abweichungen.rueckgebaeudeText')">
    </p>
    <!-- TODO Plausibilitäten-->
    <div class="d-flex flex-column lighten-5 font-weight-bold" role="alert"
         :class="hasError('rueckgebaeude') ? 'red' : 'indigo'" v-if="$store.state.berechnung.selectedBaujahr < 3">
      <div>
        <v-icon :style="getColor('rueckgebaeude')">mdi-alert</v-icon>
        <strong v-if="hasError('rueckgebaeude')" :class="getTextColor('rueckgebaeude')">Konflikt!</strong>
        <strong v-else :class="getTextColor('rueckgebaeude')">Warnung!</strong>
      </div>
      <span :class="getTextColor('rueckgebaeude')" v-html="$t('abweichungen.rueckgebaeudeError')"></span>
      <span v-if="hasError('rueckgebaeude')" class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
    </div>
    <div class="d-flex justify-center">
      <v-text-field v-model="abweichungen.rueckgebaeude" reverse label="(0,00 Euro bis 0,70 Euro)"></v-text-field>
    </div>
    <p class="validationError" role="alert" v-if="validationError.rueckgebaeudeError">
      <v-icon style="color:#c50517">mdi-alert</v-icon>
      <strong>{{ $t('abweichungen.rueckgebaeudeValidation') }}</strong>
    </p>

    <p v-html="$t('abweichungen.waermedaemmung')"></p>
    <p v-html="$t('abweichungen.waermedaemmungText')">
    </p>
    <!-- TODO Plausibilitäten-->
    <div class="d-flex flex-column lighten-5 font-weight-bold" role="alert"
         :class="hasError('waermedaemmung') ? 'red' : 'indigo'"
         v-if="$store.state.berechnung.selectedBaujahr < 3 || $store.state.berechnung.selectedBaujahr > 6 ">
      <div>
        <v-icon :style="getColor('waermedaemmung')">mdi-alert</v-icon>
        <strong v-if="hasError('waermedaemmung')" :class="getTextColor('waermedaemmung')">Konflikt!</strong>
        <strong v-else :class="getTextColor('waermedaemmung')">Warnung!</strong>
      </div>
      <span :class="getTextColor('waermedaemmung')" v-html="$t('abweichungen.waermedaemmungError')"></span>
      <span v-if="hasError('waermedaemmung')" class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
    </div>
    <div class="d-flex justify-center">
      <v-text-field v-model="abweichungen.waermedaemmung" reverse label="(0,00 Euro bis 0,90 Euro)"></v-text-field>
    </div>
    <p class="validationError" role="alert" v-if="validationError.waermedaemmungError">
      <v-icon style="color:#c50517">mdi-alert</v-icon>
      <strong>{{ $t('abweichungen.waermedaemmungValidation') }}</strong>
    </p>

    <p v-html="$t('abweichungen.fassade')"></p>
    <p v-html="$t('abweichungen.fassadeText')">
    </p>
    <p v-html="$t('abweichungen.fassadeAText')">
    </p>
    <div class="d-flex flex-column lighten-5 font-weight-bold" role="alert"
         :class="hasError('fassadeA') ? 'red' : 'indigo'"
         v-if="$store.state.berechnung.selectedBaujahr > 2">
      <div>
        <v-icon :style="getColor('fassadeA')">mdi-alert</v-icon>
        <strong v-if="hasError('fassadeA')" :class="getTextColor('fassadeA')">Konflikt!</strong>
        <strong v-else :class="getTextColor('fassadeA')">Warnung!</strong>
      </div>
      <span :class="getTextColor('fassadeA')" v-html="$t('abweichungen.fassadeAError')"></span>
      <span v-if="hasError('fassadeA')" class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
    </div>
    <div class="d-flex justify-center">
      <v-text-field v-model="abweichungen.fassadeA" :disabled="abweichungen.fassadeB.length > 0" reverse
                    label="(0,00 Euro bis 0,40 Euro)"></v-text-field>
    </div>
    <p class="validationError" role="alert" v-if="validationError.fassadeAError">
      <v-icon style="color:#c50517">mdi-alert</v-icon>
      <strong>{{ $t('abweichungen.fassadeAValidation') }}</strong>
    </p>
    <p v-html="$t('abweichungen.fassadeBText')">
    </p>
    <div class="d-flex flex-column lighten-5 font-weight-bold" role="alert"
         :class="hasError('fassadeB') ? 'red' : 'indigo'"
         v-if="$store.state.berechnung.selectedBaujahr > 2">
      <div>
        <v-icon :style="getColor('fassadeB')">mdi-alert</v-icon>
        <strong v-if="hasError('fassadeB')" :class="getTextColor('fassadeB')">Konflikt!</strong>
        <strong v-else :class="getTextColor('fassadeB')">Warnung!</strong>
      </div>
      <span :class="getTextColor('fassadeB')" v-html="$t('abweichungen.fassadeAError')"></span>
      <span v-if="hasError('fassadeB')" class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
    </div>
    <div class="d-flex justify-center">
      <v-text-field v-model="abweichungen.fassadeB" :disabled="abweichungen.fassadeA.length > 0" reverse
                    label="(-0,25 Euro bis 0,00 Euro)"></v-text-field>
    </div>
    <p class="validationError" role="alert" v-if="validationError.fassadeBError">
      <v-icon style="color:#c50517">mdi-alert</v-icon>
      <strong>{{ $t('abweichungen.fassadeBValidation') }}</strong>
    </p>


    <p v-html="$t('abweichungen.zusatz')"></p>
    <p v-html="$t('abweichungen.zusatzText')">
    </p>
    <div class="d-flex justify-center">
      <v-text-field v-model="abweichungen.zusatz" reverse
                    label="Falls zutreffend, geben Sie hier bitte einen Wert ein."></v-text-field>
    </div>
    <p class="validationError" role="alert" v-if="validationError.zusatzError">
      <v-icon style="color:#c50517">mdi-alert</v-icon>
      <strong>{{ $t('abweichungen.zusatzValidation') }}</strong>
    </p>

    <!-- BUTTON SECTION -->
    <div class="d-flex justify-center justify-space-around my-3">
      <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span
          class="black--text subtitle-1">Zurück</span></v-btn>
      <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span
          class="black--text subtitle-1">Weiter</span></v-btn>
    </div>
    <!-- INFO SECTION -->
    <div>
      <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
        <v-expansion-panels>
          <v-expansion-panel ref="infoPanel">
            <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen"
                                      role="heading" aria-level="2" class="subtitle-1 py-1">Info
            </v-expansion-panel-header>
            <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading"
                                      aria-level="2" class="subtitle-1 py-1">Info
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h3>Orientierungshilfe bei begründeten Abweichungen</h3><br/>

              <p>Bei der ortsüblichen Miete handelt es sich nicht um einen Punktwert, sondern um einen Bereich
                (Spannen).</p>

              <p>
                Für Abweichungen von der durchschnittlichen ortsüblichen Miete ist eine
                Begründung erforderlich. Hierzu geben Sie bitte die Höhe der eventuell anzusetzenden
                Abweichungen für jeden einzelnen Faktor ein. Bitte beachten Sie die Hinweise zu
                Grenzwerten und maximalen Abweichungen.
              </p>

              <p>Abweichungen vom Durchschnittswert nach oben
                oder unten können aus folgenden Gründen entstehen:
              </p>

              <ul>
                <li>Die Wohnung weicht vom jeweiligen Standard
                  der aufgeführten
                  <a title="Öffnet die Tabelle mit den Zu- und Abschlägen in Euro pro m² und Monat"
                     href="/berechnung.html#/zuschlaege">Zu- und Abschlagsmerkmale</a>
                  erheblich ab, oder
                </li>
                <li>es liegen Faktoren vor, die den Mietpreis beeinflussen
                  und für die in der statistischen Analyse
                  zwar Tendenzen erkennbar waren, die aber
                  aus statistischer Sicht nicht zu einer nachweisbaren
                  (signifikanten) Verbesserung des Mietspiegel-Modells beitragen, um als
                  Zu- oder Abschlag aufgenommen zu werden, oder
                </li>
                <li>es liegen weitere mietpreisbeeinflussende Faktoren
                  vor, die durch die dem Mietspiegel zugrunde
                  liegende repräsentative Stichprobe
                  nicht vollständig erfasst werden.
                </li>
              </ul>

              <p>Bei Abweichungen von der durchschnittlichen
                ortsüblichen Miete innerhalb der Spannen können
                die oben angegebenen Merkmale eine
                Begründung liefern. Die angegebenen Faktoren
                und die Höhe der Zu- und Abschläge stellen dabei
                eine Empfehlung zur Anwendung bei begründeten
                Abweichungen von der durchschnittlichen ortsüblichen
                Miete dar.</p>
              <p>Weitere, hier nicht genannte
                Merkmale zur Begründung können als zusätzliche Begründungen berücksichtigt
                werden. <br> <br>
                Die begründeten Abweichungen stellen eine Orientierungshilfe dar, um die Anwendung der Spannen zu
                erleichtern.
                Die angegebenen Beträge (zum Beispiel bis zu - 0,70 Euro pro m² und Monat) sind als nicht
                bindende Vorgabe zu verstehen.
                Sie dürfen jedoch nicht über- beziehungsweise unterschritten werden. Beim Ansatz von begründeten
                Abweichungen sollten die
                tatsächlichen Gegebenheiten der Wohnung im Einzelfall berücksichtigt werden: Alter, Qualität
                oder Ähnliches können Anhaltspunkte
                für die Bewertung im vorgegebenen Rahmen (zum Beispiel von 0 bis - 0,70 Euro pro m² und Monat) sein.
              </p>

              <h3>Hinweise zu Grenzwerten und maximalen Abweichungen</h3><br/>
              <p>Grenzwerte in Klammern müssen eingehalten werden. Andernfalls werden die
                eingegebenen Werte auf die zulässigen Beträge reduziert.
                Beachten Sie bitte, dass die durchschnittliche ortsübliche Miete mit begründeten
                Abweichungen die untere beziehungsweise obere maximale Spanne nicht unter- beziehungsweise
                überschreiten darf. Andernfalls werden vom Programm die untere beziehungsweise obere
                maximale Spanne übernommen.
              </p>


              <h3><a id="info-schwellenwerte" name="info-schwellenwerte"></a>Schwellenwerte</h3><br/>

              <p>
                Sogenannte Schwellenwerte treten bei einigen <a href="/berechnung.html#/zuschlaege">Zu- und
                Abschlagsmerkmalen</a> auf. Dabei wird ein
                Zu- oder Abschlag vergeben, wenn zum Beispiel ein bestimmtes Baujahr oder eine bestimmte Fläche über-
                beziehungsweise unterschritten wird. Derartige Veränderungen eines Effekts finden in der Realität jedoch
                fließend statt.</p>

              <h3>Beispiel für Schwellenwerte </h3><br/>
              <p>
                So kann etwa für eine erfolgte Modernisierung des Bades bei einem Baujahr 1999 kein Zuschlag vergeben
                werden.
                Per Definition ist dies nur bei einem Baujahr vor 1999 möglich. Da die Veränderung des Effekts
                allerdings nicht
                sprunghaft bei einem bestimmten Baujahr eintritt, kann für eine Modernisierung des Bades, die bis auf
                das Baujahr
                des Gebäudes der Definition der Modernisierungsmaßnahmen entspricht, ein reduzierter Zuschlag
                berücksichtigt
                werden, wenn die Wohnung in einem Gebäude mit Baujahr 1999 liegt.<br/> Die begründeten Abweichungen sind
                in Grenzfällen
                flexibel zu handhaben. Zum Beispiel ist der Schwellenwert für das Baujahr (nach 1948) bei der Wärmedämmung 
                der Außenwände nicht bindend. So ist ein reduzierter Zuschlag auch für eine Wärmedämmung der Außenwände von 
                Gebäuden, die 1948 oder wenige Jahre früher errichtet wurden, denkbar.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import {Component, Vue} from 'vue-property-decorator';
import {EventBus} from '../eventbus';
import {createNamespacedHelpers, mapActions} from 'vuex';

const {mapMutations, mapState} = createNamespacedHelpers('error')
const {mapGetters} = createNamespacedHelpers('user')

@Component({
  computed: {...mapGetters(['hasPermission'])},
  methods: {
    ...mapState({abweichungenError: 'abweichungen'}),
    ...mapMutations(['SET_ABWEICHUNGEN_ERROR']),
    ...mapActions('berechnung', ['SELECT_ABWEICHUNGEN']),
    ...mapActions('error', ['CHECK_BAUJAHR_ERROR']),
    ...mapActions('error', ['CHECK_TERRASSEBALKON_ERROR']),
  }
})
export default class BegruendeteAbweichungen extends Vue {

  get abweichungGesetzt() {
    return Object.keys(this.abweichungen).some(key => this.abweichungen[key] != null
        && this.abweichungen[key] != 0)
  }

  /*
   * Array of objects. Each object contains the related components error function for
   * one item of abweichungen
   */
  get selectedErrors() {
    return this.selectedData.map(item => this.abweichungenErrors[item])
  }

  /*
   * indicates if any of the items' error functions (concerning selections of other components)
   * is evaluating to true with the stored values of the other components
   */
  get error() {
    return this.selectedData.some(item => Object.keys(this.abweichungenErrors[item])
        .some(error => //e.g. selectedKamin
            this.abweichungenErrors[item][error](this.$store.state.berechnung[error])))
  }

  get selectedData() {
    //those that can have an error and have text.length > 0 //TODO null check ??
    return Object.keys(this.abweichungenErrors).filter(item => this.abweichungen[item] != 0)
  }

  data() {
    return {
      index: 18,
      errorText: false,
      abweichungen: {
        wasser: this.$store.state.berechnung.abweichungen.wasser != 0 ? this.$store.state.berechnung.abweichungen.wasser.toLocaleString('de-DE', {minimumFractionDigits: 2}) : '',
        rueckgebaeude: this.$store.state.berechnung.abweichungen.rueckgebaeude != 0 ? this.$store.state.berechnung.abweichungen.rueckgebaeude.toLocaleString('de-DE', {minimumFractionDigits: 2}) : '',
        waermedaemmung: this.$store.state.berechnung.abweichungen.waermedaemmung != 0 ? this.$store.state.berechnung.abweichungen.waermedaemmung.toLocaleString('de-DE', {minimumFractionDigits: 2}) : '',
        fassadeA: this.$store.state.berechnung.abweichungen.fassadeA != 0 ? this.$store.state.berechnung.abweichungen.fassadeA.toLocaleString('de-DE', {minimumFractionDigits: 2}) : '',
        fassadeB: this.$store.state.berechnung.abweichungen.fassadeB != 0 ? this.$store.state.berechnung.abweichungen.fassadeB.toLocaleString('de-DE', {minimumFractionDigits: 2}) : '',
        zusatz: this.$store.state.berechnung.abweichungen.zusatz != 0 ? this.$store.state.berechnung.abweichungen.zusatz.toLocaleString('de-DE', {minimumFractionDigits: 2}) : ''
      },
      abweichungenErrors: {
        rueckgebaeude: {
          selectedBaujahr: function (el) {
            return el < 3
          }
        },
        waermedaemmung: {
          selectedBaujahr: function (el) {
            return el < 3 || el > 6
          }
        },
        fassadeA: {
          selectedBaujahr: function (el) {
            return el > 2
          }
        },
        fassadeB: {
          selectedBaujahr: function (el) {
            return el > 2
          }
        }
      },
      //field validation errors
      validationError: {
        rueckgebaeude: false,
        waermedaemmung: false,
        wasserError: false,
        rueckgebaeudeError: false,
        waermedaemmungError: false,
        fassadeAError: false,
        fassadeBError: false,
        zusatzError: false
      },
      expanded: false
    };
  }

  changedExpansion(event) {
    this.expanded = !this.expanded
    event.currentTarget.setAttribute('aria-expanded', this.expanded)
  }

  mounted() {
    EventBus.$emit('scroll', this.$data.index)
    window.scrollTo(0, 0);
    this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
  }

  save() {
    EventBus.$emit('getSaveData', this.index)
  }

  hasError(item) {
    return this.selectedData.includes(item) && this.abweichungenError
  }

  checkForm() {
    Object.keys(this.validationError).forEach(key => this.validationError[key] = false)
    console.log(this.validationError)

    let wasser = this.formatNumber(this.abweichungen.wasser)
    if (isNaN(wasser)
        || wasser > 0.0
        || wasser < -0.7) {
      this.validationError.wasserError = true;
    }

    let rueckgebaeude = this.formatNumber(this.abweichungen.rueckgebaeude)
    if (isNaN(rueckgebaeude)
        || rueckgebaeude > 0.7
        || rueckgebaeude < 0.0) {
      this.validationError.rueckgebaeudeError = true;
    }

    let waermedaemmung = this.formatNumber(this.abweichungen.waermedaemmung)
    if (isNaN(waermedaemmung)
        || waermedaemmung > 0.9
        || waermedaemmung < 0.0) {
      this.validationError.waermedaemmungError = true;
    }

    let fassadeA = this.formatNumber(this.abweichungen.fassadeA)
    if (isNaN(fassadeA)
        || fassadeA > 0.4
        || fassadeA < 0.0) {
      this.validationError.fassadeAError = true;
    }

    let fassadeB = this.formatNumber(this.abweichungen.fassadeB)
    if (isNaN(fassadeB)
        || fassadeB > 0.0
        || fassadeB < -0.25) {
      this.validationError.fassadeBError = true;
    }

    let zusatz = this.formatNumber(this.abweichungen.zusatz)
    if (isNaN(zusatz)
        || zusatz < -4.5
        || zusatz > 4.0) {
      this.validationError.zusatzError = true;
    }

    return !Object.keys(this.validationError).map(key => this.validationError[key]).some(el => el === true);
  }

  formatNumber(value) {
    return value.toString().replace(",", ".").replace(/ /g, "")
  }

  parseValue(value) {
    let parsed = parseFloat(this.formatNumber(value))
    if (isNaN(parsed)) {
      return ""
    }
    return parsed
  }

  next() {
    if (this.checkForm()) {
      for (const [key, value] of Object.entries(this.abweichungen)) {
        this.abweichungen[key] = this.parseValue(value)
      }
      this.SELECT_ABWEICHUNGEN({
        abweichungGesetzt: true,
        abweichungen: this.abweichungen,
        selectedAbweichungenErrors: this.selectedErrors
      })
      this.CHECK_BAUJAHR_ERROR()
      this.CHECK_TERRASSEBALKON_ERROR()
      if (this.error) {
        console.log("found abweichungen error")
        this.SET_ABWEICHUNGEN_ERROR(true)
        for (const [key, value] of Object.entries(this.abweichungen)) {
          this.abweichungen[key] = value.toLocaleString('de-DE', {minimumFractionDigits: 2})
        }
        let alert;
        let errorKeys = Object.keys(this.abweichungenErrors)
        errorKeys.forEach(key => {
          if (this.hasError(key)) {
            this.errorText = true
            alert = document.querySelector('.' + key)
            alert.removeAttribute('role')
            alert.setAttribute("role", "alert")
          }
          if (this.errorText) {
            window.scrollTo(0, 0);
          }
        })
      } else {
        this.SET_ABWEICHUNGEN_ERROR(false)
        this.$router.push('betriebskosten')
      }
    } else {
      this.errorText = true
      document.querySelectorAll('.validationError').forEach(alert => {
        alert.removeAttribute('role')
        alert.setAttribute("role", "alert")
      })
      window.scrollTo(0, 0);
    }
  }

  back() {
    this.$router.push('modernisierteFenster')
  }

  getColor(item) {
    if (this.hasError(item)) {
      return "color:#c50517"
    } else {
      return "color:indigo" //blue !?
    }
  }

  getTextColor(item) {
    if (this.hasError(item)) {
      return "red--text"
    } else {
      return "indigo--text"
    }
  }
}
</script>
